import { render } from "./WarningDetail.vue?vue&type=template&id=32dc79f8"
import script from "./WarningDetail.vue?vue&type=script&lang=js"
export * from "./WarningDetail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__